/* @flow */
import * as React from 'react';
import { Route } from 'react-router-dom';
import { type GetRoutesFn } from './types';
import withRouteTracker from 'common/middleware/RouteTracker';
import SectionWrap from 'common/components/common/SectionWrap';
import { Loader } from 'common/components/core/loader/Loader';
import Products from 'common/enums/Product';

const LiveViewRoutesContainer = React.lazy(() =>
    import('trackiq-app/LiveViewRoutesContainer')
);

const LiveViewRoutesContainerSection = withRouteTracker(props => {
    return (
        <SectionWrap>
            <React.Suspense fallback={<Loader active />}>
                <LiveViewRoutesContainer {...props} />
            </React.Suspense>
        </SectionWrap>
    );
}, Products.MOTION_TRACK);

const SingleRiderV1RoutesContainer = React.lazy(() =>
    import('trackiq-app/SingleRiderV1RoutesContainer')
);

const SingleRiderV1RoutesContainerSection = withRouteTracker(props => {
    return (
        <SectionWrap>
            <React.Suspense fallback={<Loader active />}>
                <SingleRiderV1RoutesContainer {...props} />
            </React.Suspense>
        </SectionWrap>
    );
}, Products.MOTION_TRACK);

const getRoutes: GetRoutesFn = ({ visibleSections, match }) => {
    return [
        visibleSections.showLiveViewSection && (
            <Route
                path={`${match.path}/live_view`}
                component={LiveViewRoutesContainerSection}
            />
        ),
        visibleSections.showLiveViewSection && (
            <Route
                path={`${match.path}/user/:userId`}
                component={SingleRiderV1RoutesContainerSection}
            />
        )
    ].filter(Boolean);
};

export default getRoutes;
